import { differenceInSeconds } from 'date-fns';
import { useEffect, useState } from 'react';

import { getLocalTime, secondsToTime } from 'containers/EmployeeTimeClock/shared/helper';
import { useTimeClockStore } from 'store/useTimeClockStore';

const useAdditionalTimeElapsed = (breakStartTime: any, breakDuration: number) => {
  const [additionalTimeElapsed, setAdditionalTimeElapsed] = useState<any>(0);

  const timeClockDetails: any = useTimeClockStore(state => state.timeClock);

  useEffect(() => {
    const breakStart = breakStartTime ? new Date(breakStartTime) : null;

    if (!breakStart) return;

    const currentTime = new Date();
    const localBreakStartTime = getLocalTime(breakStart, timeClockDetails?.userTimezone);
    const elapsedTime = differenceInSeconds(currentTime, localBreakStartTime) - (breakDuration || 0);
    setAdditionalTimeElapsed(elapsedTime);

    const activeInterval = setInterval(() => {
      setAdditionalTimeElapsed((prev: any) => prev + 1);
    }, 1000);

    return () => {
      clearInterval(activeInterval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return secondsToTime(additionalTimeElapsed, '');
};
export default useAdditionalTimeElapsed;
